import PROFESSIONAL_ROUTES from '@/presentation/modules/professional/constants/routes';

const professionalRoutes = [
	{
		name: PROFESSIONAL_ROUTES.root.name,
		path: PROFESSIONAL_ROUTES.root.path,
		redirect: PROFESSIONAL_ROUTES.root.redirect,
		meta: PROFESSIONAL_ROUTES.root.meta,
		component: PROFESSIONAL_ROUTES.root.component,
		children: [
			{
				name: PROFESSIONAL_ROUTES.dashboard.name,
				path: PROFESSIONAL_ROUTES.dashboard.path,
				meta: PROFESSIONAL_ROUTES.dashboard.meta,
				component: PROFESSIONAL_ROUTES.dashboard.component,
			},
			{
				name: PROFESSIONAL_ROUTES.bookings.name,
				path: PROFESSIONAL_ROUTES.bookings.path,
				meta: PROFESSIONAL_ROUTES.bookings.meta,
				component: PROFESSIONAL_ROUTES.bookings.component,
			},
			{
				name: PROFESSIONAL_ROUTES.calendar.name,
				path: PROFESSIONAL_ROUTES.calendar.path,
				meta: PROFESSIONAL_ROUTES.calendar.meta,
				component: PROFESSIONAL_ROUTES.calendar.component,
			},
			{
				name: PROFESSIONAL_ROUTES.services.name,
				path: PROFESSIONAL_ROUTES.services.path,
				meta: PROFESSIONAL_ROUTES.services.meta,
				component: PROFESSIONAL_ROUTES.services.component,
			},
			{
				name: PROFESSIONAL_ROUTES.workplaces.name,
				path: PROFESSIONAL_ROUTES.workplaces.path,
				meta: PROFESSIONAL_ROUTES.workplaces.meta,
				component: PROFESSIONAL_ROUTES.workplaces.component,
			},
			{
				name: PROFESSIONAL_ROUTES.profile.name,
				path: PROFESSIONAL_ROUTES.profile.path,
				meta: PROFESSIONAL_ROUTES.profile.meta,
				component: PROFESSIONAL_ROUTES.profile.component,
			},
		],
	},
];

export default professionalRoutes;
